import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_ROOKIE_DAY_PROVIDERS = gql`
  query GetRookieDayProviders($districtId: Int!, $schoolId: Int!) {
    rookiedayProviders(districtId: $districtId, schoolId: $schoolId) {
      id
      uuid
      name
      companySize {
        id
        name
      }
      founded
      locations {
        id
        name
        address {
          id
          street
          number
          addressCity {
            id
            name
          }
        }
      }
      companyBenefits {
        id
        name
      }
      mediaGallery {
        galleryItems {
          image {
            ...imageFields
          }
        }
      }
      headerPicture {
        id
        name
        image {
          ...imageFields
        }
      }
      companyProfilePicture {
        id
        name
        image {
          ...imageFields
        }
      }
      jobs {
        id
        name
        description

        image {
          ...imageFields
        }
        interestFields {
          id
          interestName
        }
        jobSalary {
          id
          entryValue
        }
        scholasticDuration {
          durationName
        }
        jobEducationalPaths {
          id
          name
        }
      }
    }
  }
  ${ImageFragment}

`;
